import { FC } from "react"

import { useTranslation } from "react-i18next"

import { CurrencyFiatLimit } from "services/settings/type"

import { NumberField } from "../inputs/NumberField"

interface LimitsWithdrawalFieldsProps {
  idPrefix: string
  // Path to the withdrawal object inside the limits tree, e.g. ["withdrawal", "fiat"] or ["currencyLimits", "BRL", "withdrawal"].
  basePath: string[]
  values: CurrencyFiatLimit["withdrawal"]
  // Already-translated noun for the label, e.g. "Fiat Withdrawal" / "Crypto Withdrawal" / "Withdrawal".
  typeLabel: string
  currencyCode?: string
  onUpdate: (path: string[], value: string) => void
  disabled?: boolean
}

// Min/Max grid for withdrawal thresholds.
export const LimitsWithdrawalFields: FC<LimitsWithdrawalFieldsProps> = ({
  idPrefix,
  basePath,
  values,
  typeLabel,
  currencyCode,
  onUpdate,
  disabled
}) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  const fields = [
    { key: "min", bound: "min", value: values.min, path: ["min"] },
    { key: "max", bound: "max", value: values.max, path: ["max"] }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
      {fields.map((field) => (
        <NumberField
          key={field.key}
          id={`${idPrefix}-${field.key}`}
          label={t("settings.limits.withdrawalFieldLabel", { bound: t(`settings.limits.${field.bound}`), type: typeLabel })}
          value={field.value}
          onChange={(v) => onUpdate([...basePath, ...field.path], v)}
          centsDisplay
          currencyCode={currencyCode}
          disabled={disabled}
        />
      ))}
    </div>
  )
}
